import React from 'react'
import {
  Icon,
  InfoPill,
  InitialsAvatar,
  LabelValue,
  constants,
  utils,
} from '@adc/ui-core'
import classnames from 'classnames/bind'
import ClosingOverview from '../closingOverview'
import { ClosingGroupProps } from '../types'
import styles from './styles.scss'
import { getInitials, GROUP_LABEL } from '../closingOverview/helpers'

const cx = classnames.bind(styles)
const { ColorNames } = constants
const { formatters } = utils

const ClosingGroup: React.FC<ClosingGroupProps> = ({
  groupingKey,
  groupLabel,
  closings,
  computedAggregations,
  isExpanded,
  onToggle,
  slots,
  onPartyClick,
  elmId = 'closing-group',
}) => {
  return (
    <div className={cx('accordion-container')} data-elm-id={elmId}>
      <div className={cx('header-content')} onClick={onToggle}>
        <div className={cx('group-label-info')}>
          <div className={cx('group-label')}>
            <InitialsAvatar
              initials={getInitials(groupLabel)}
              size='medium'
              identifier={groupLabel}
              tooltipContent={
                <div>
                  <strong>{groupLabel}</strong>
                </div>
              }
            />
            <LabelValue label={GROUP_LABEL[groupingKey]} value={groupLabel} />
          </div>
          <Icon name={isExpanded ? 'angle down' : 'angle left'} size='big' />
        </div>
        <div className={cx('aggregated-data')}>
          <InfoPill
            content={`${closings.length} Closings`}
            iconName='list'
            size='small'
            backgroundColor={ColorNames.GrayLight}
            foregroundColor={ColorNames.GrayDark}
          />
          {computedAggregations?.map(aggregation => (
            <InfoPill
              key={aggregation.key}
              content={`${aggregation.label}: ${formatters.formatMoney(
                aggregation.amount,
                {},
                false,
                '$0'
              )}`}
              iconName='info circle'
              size='small'
              backgroundColor={ColorNames.GrayLight}
              foregroundColor={ColorNames.GrayDark}
            />
          ))}
        </div>
      </div>
      {isExpanded && (
        <div className={cx('expanded-content')}>
          {closings.map((closing, index) => (
            <ClosingOverview
              key={index}
              closingMethod={closing}
              slots={slots}
              onPartyClick={onPartyClick}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ClosingGroup
